<template>
  <div id="home">
    <WsAppBar />
    <header class="header">
      <v-container class="fill-height">
        <v-row>
          <v-col
            cols="12"
            md="6"
            data-aos="fade-down-right"
            data-aos-easing="ease-in-out"
          >
            <h1 class="nerrow-lines heading-primary">
              <!-- <big> -->
              <ws-gradient-text>
                {{ $t("EASY, ON-DEMAND WAREHOUSING AND DELIVERY") }}
              </ws-gradient-text>
              <!-- </big> -->
            </h1>
            <p
              :class="
                isRtl
                  ? 'body-1 text-white my-12 pl-10'
                  : 'body-1 text-white my-12 pr-10'
              "
            >
              {{
                $t(
                  "If you’re a seller wanting flexible storage and fulfilment, whether for your e-commerce business, B2B or B2C – we’ve put the solution at your fingertips."
                )
              }}
            </p>

            <div>
              <v-btn
                light
                color="white"
                :class="isRtl ? 'ml-3' : 'mr-3'"
                to="/quotes/create"
              >
                Get a Quote
              </v-btn>
              <v-btn light color="white" outlined xhref="#get-a-call">
                {{ $t("Lets Chat") }}
              </v-btn>
            </div>
          </v-col>
          <v-col cols="12" md="6">
            <v-img
              data-aos="fade-down-left"
              data-aos-easing="ease-in-out"
              eager
              :src="require('@/assets/images/landing/home-banner.png')"
              :lazy-src="require('@/assets/images/landing/home-banner.png')"
            />
          </v-col>
        </v-row>
      </v-container>
      <div
        class="header__secondary pb-10"
        :class="$vuetify.breakpoint.smAndDown && 'mt-0'"
      >
        <v-container class="fill-height">
          <v-row>
            <v-col cols="12" md="6">
              <h1
                class="text-white heading-secondary"
                data-aos="fade-up-right"
                data-aos-easing="ease-in-out"
              >
                {{ $t("The Better Way") }}<br />
                {{ $t("to") }}
                <span id="msg" class="text-decoration-underline"></span>
              </h1>
              <p
                :class="
                  isRtl
                    ? 'body-1 font-weight-bold text-white my-6 pl-10'
                    : 'body-1 font-weight-bold text-white my-6 pr-10'
                "
                data-aos="fade-up-right"
                data-aos-easing="ease-in-out"
              >
                {{
                  $t("Only pay for the space you use. No long-term contracts.")
                }}
              </p>
              <v-btn
                light
                color="white"
                :class="isRtl ? 'ml-3' : 'mr-3'"
                data-aos="fade-right"
                data-aos-easing="ease-in-out"
              >
                {{ $t("Lets Chat") }}
              </v-btn>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </header>
    <section class="section-lg">
      <v-container>
        <h2
          class="text-center mb-12 nerrow-lines heading-tertiary"
          data-aos="zoom-in"
          data-aos-easing="ease-in-out"
        >
          <span class="heading-tertiary__first"
            >{{ $t("Solving the hassles of your") }}
          </span>
          <br />
          <span class="heading-tertiary__second">{{
            $t("storage and delivery")
          }}</span>
        </h2>

        <v-row
          :class="{ 'ws-odd-row': i % 2 }"
          v-for="(sd, i) in storageDelivery"
          :key="i"
        >
          <v-col cols="12" md="6" class="pa-4">
            <v-img
              eager
              :src="sd.imageUrl"
              data-aos="flip-left"
              data-aos-easing="ease-in-out"
              data-aos-anchor-placement="top-bottom"
            >
            </v-img>
          </v-col>

          <v-col
            cols="12"
            md="6"
            class="d-flex flex-column justify-center"
            data-aos="zoom-in"
            data-aos-easing="ease-in-out"
          >
            <p class="body-1 font-weight-bold text-muted" v-html="sd.pretext" />

            <h1 class="nerrow-lines colored-heading">
              <div class="text-primary" v-text="sd.title[0]" />
              <WsGradientTextSecondary v-if="sd.toggleGradient === true">
                {{ sd.title[1] }}
              </WsGradientTextSecondary>
              <ws-gradient-text v-else>{{ sd.title[1] }}</ws-gradient-text>
              <div class="text-primary" v-text="sd.title[2]" />
            </h1>

            <p
              class="mt-3 body-1 font-weight-bold text-muted"
              v-html="sd.text"
            />

            <div>
              <v-btn
                small
                color="info"
                text
                xhref="#get-a-call"
                @click="
                  logGAEvent(
                    'Public',
                    'Let\'s Chat',
                    `storage and delivery (${sd.title[1].trim()})`
                  );
                  $vuetify.goTo('#get-a-call');
                "
              >
                {{ $t("Lets Chat") }}
                <v-icon small>mdi-arrow-right</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-row>
      </v-container>
    </section>
    <section class="section-lg bg-dark">
      <v-container>
        <h2
          class="text-center text-white mb-12 nerrow-lines heading-tertiary"
          data-aos="fade-up"
          data-aos-easing="ease-in-out"
        >
          <span class="heading-tertiary__first"
            >{{ $t("How it works?") }}
          </span>
          <br />
          <span class="heading-tertiary__second">{{
            $t("We Store. You Grow")
          }}</span>
        </h2>

        <!-- <template>
          <v-carousel
            cycle
            hide-delimiter-background
            vertical-delimiters="right"
          >
            <v-carousel-item
              v-for="(item, i) in items"
              :key="i"
              reverse-transition="fade-transition"
              transition="fade-transition"
            >
              <v-row>
                <v-col cols="6">
                  <v-img :src="item.src"> </v-img>
                </v-col>
                <v-col class="bg-secondary" cols="6"> test </v-col>
              </v-row>
            </v-carousel-item>
          </v-carousel>
        </template> -->
      </v-container>
    </section>
    <section class="section-lg">
      <v-container>
        <h2
          class="text-center mb-12 nerrow-lines heading-tertiary"
          data-aos="fade-down"
          data-aos-easing="ease-in-out"
        >
          <span class="heading-tertiary__first"
            >{{ $t("Our easy, affordable, omnichannel") }}
          </span>
          <br />
          <span class="heading-tertiary__second">
            {{ $t("Warehousing and Delivery Capabilities") }}</span
          >
        </h2>
        <v-row>
          <v-col cols="12" md="5">
            <v-list dense class="transparent">
              <v-list-item
                class="list-item"
                dense
                data-aos="fade-up"
                data-aos-easing="ease-in-out"
                v-for="p in [
                  this.$t('Network of warehouses'),
                  this.$t('No IT integration required'),
                  this.$t('Case Picking'),
                  this.$t('Pick & Pack/Kitting'),
                  this.$t('Cross-Docking'),

                  this.$t('Shipment Consolidation'),
                  this.$t('Transloading'),
                  this.$t('Fulfilment'),
                  this.$t('Non-palletized & palletized storage'),
                  this.$t('Palletization & Pallet Rebuild'),
                  this.$t('Forward Stocking Locations'),
                  this.$t('Labeling / barcoding'),
                  this.$t('Custom Services'),
         
                  this.$t('B2B and B2C Distribution'),
                  this.$t('Order Management'),
                ]"
                :key="p"
              >
                <v-list-item-icon :class="isRtl ? 'ml-2':'mr-2'">
                  <v-icon color="gray">mdi-check-circle-outline</v-icon>
                </v-list-item-icon>
                <v-list-item-content>
                  <span class="text-muted" v-html="p" />
                </v-list-item-content>
              </v-list-item> </v-list
          ></v-col>
          <v-col cols="12" md="7" offset-md="0" class="pt-6">
            <v-img
              data-aos="fade-down-left"
              data-aos-easing="ease-in-out"
              eager
              :src="require('@/assets/images/landing/capabilities.jpg')"
              :lazy-src="require('@/assets/images/landing/capabilities.jpg')"
            />
          </v-col>
        </v-row>
      </v-container>
    </section>

    <v-img
      eager
      aspect-ratio="4"
      :position="$vuetify.breakpoint.mdAndUp ? '100% 20%' : 'center center'"
      :src="require('@/assets/images/landing/heavy-lifting-scaled.jpg')"
      class="flex-grow section-lg pt-0"
      :min-height="
        $vuetify.breakpoint.smAndDown
          ? 'Calc(100vh - 56px)'
          : 'Calc(100vh - 63px)'
      "
    >
      <v-container>
        <v-row>
          <v-col
            cols="12"
            class="pl-15"
            md="6"
            data-aos="fade-up"
            data-aos-easing="ease-in-out"
          >
            <h1 class="text-white">
              {{$t('Solving the hassles of your')}}<br />
              {{$t('storage and delivery.')}}
            </h1>
            <p class="text-white body-1 font-weight-bold font-weight-bold mt-5">
              {{$t('We will do the heavy lifting for you!')}}
            </p>
          </v-col>
          <v-col
            cols="12"
            lg="4"
            md="6"
            sm="12"
            class="mt-16"
            data-aos="fade-up-left"
            data-aos-easing="ease-in-out"
          >
            <PortalForm
              class="mt-8"
              title="Get a Call"
              title-color="secondary"
              color="primary_1"
              light
              comments-label="Comments / Questions"
              submit-color="info"
              form-type="Customer Interest"
            />
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <LandingFooter />
  </div>
</template>

<script>
import WsGradientText from "../../../components/ws-gradient-text.vue";
import WsGradientTextSecondary from "../../../components/ws-gradient-text-secondary.vue";
import PortalForm from "../../../components/portal-form.vue";
import LandingFooter from "../../../components/landing-footer.vue";
import WsAppBar from "../../../components/ws-app-bar.vue";

export default {
  components: {
    WsGradientText,
    WsGradientTextSecondary,
    PortalForm,
    LandingFooter,
    WsAppBar,
  },
  data() {
    return {
      items: [
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/sky.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/bird.jpg",
        },
        {
          src: "https://cdn.vuetifyjs.com/images/carousel/planet.jpg",
        },
      ],
      words: [this.$t("Store"), this.$t("Ship"), this.$t("Deliver")],
      storageDelivery: [
        {
          pretext: this.$t(
            "Tired of living with boxes?<br>Don’t want to be tied down by expensive long-term warehouse contracts?"
          ),
          title: [
            this.$t("Ultra-flexible,"),
            this.$t("on-demand"),
            this.$t("warehousing"),
          ],
          text: this.$t(
            "We provide operations and logistics for small, medium and ecommerce businesses. Store a little or a lot – and only pay for the space and time you need."
          ),
          imageUrl: require("@/assets/images/landing/storage.jpg"),
          toggleGradient: true,
        },
        {
          pretext: this.$t(
            "Frustrated with driving back and forth, cramming your car full of boxes, or paying expensive couriers?"
          ),
          title: [
            this.$t("Hassle-free,"),
            this.$t("same-day"),
            this.$t("delivery"),
          ],
          text: this.$t(
            "We offer simple pricing, same day delivery and end to end fulfillment solutions."
          ),
          imageUrl: require("@/assets/images/landing/ship.jpg"),
          toggleGradient: false,
        },
        {
          pretext: this.$t(
            "Wasting time and money on managing cancellations or returns?"
          ),
          title: [
            this.$t("Fast,"),
            this.$t("cost-effective"),
            this.$t("Returns"),
          ],
          text: this.$t(
            "Through our extensive network, we’ve got it sorted. No hassle. No financial headache."
          ),
          imageUrl: require("@/assets/images/landing/deliver.jpg"),
          toggleGradient: false,
        },
      ],
    };
  },
  mounted() {
    this.typingEffect(document.getElementById("msg"), this.words, {
      typingSpeed: 200,
      erasingSpeed: 100,
      delayAfterTyping: 500,
    });
  },

  methods: {
    typingEffect(
      targetTextElement,
      words = [],
      option = {
        typingSpeed: 100,
        erasingSpeed: 100,
        delayAfterTyping: 1000,
      }
    ) {
      let currentwordIndex = 0;

      const typeWord = (word = "") => {
        let charIndex = 0;
        let typeWordInterval;
        typeWordInterval = setInterval(() => {
          if (charIndex < word.length) {
            targetTextElement.innerHTML += word[charIndex];
            charIndex++;
          } else {
            clearInterval(typeWordInterval);
            setTimeout(eraseWord, option.delayAfterTyping);
          }
        }, option.typingSpeed);
      };

      const eraseWord = () => {
        let charIndex = targetTextElement.innerHTML.length - 1;
        let eraseWordInterval = setInterval(() => {
          if (charIndex >= 0) {
            targetTextElement.innerHTML = targetTextElement.innerHTML.slice(
              0,
              -1
            );
            charIndex--;
          } else {
            clearInterval(eraseWordInterval);

            if (currentwordIndex <= words.length - 2) {
              currentwordIndex++;
            } else {
              currentwordIndex = 0;
            }
            typeWord(words[currentwordIndex]);
          }
        }, option.erasingSpeed);
      };

      typeWord(words[currentwordIndex]);
    },
  },
};
</script>

<style scoped lang="scss">
#home {
  overflow: hidden;
}
.heading-primary {
  font-family: "Montserrat-SemiBold";
  font-size: 3.3rem;
  @media (max-width: 990px) {
    font-size: 2rem;
  }
  @media (max-width: 600px) {
    font-size: 2.5rem;
  }
}
.heading-secondary {
  font-size: 2.5rem;
  font-weight: 300;
}
.heading-tertiary {
  color: var(--v-primary-base);
  &__first {
    font-size: 1.3rem;
  }
  &__second {
    font-size: 2rem;
  }
}
.colored-heading {
  font-size: 2.8rem;
  line-height: 3rem;
}
.list-item {
  max-height: 33px;
  font-size: 1.1rem;
  @media (max-width: 990px) {
    font-size: 0.9rem;
  }
  @media (max-width: 770px) {
    font-size: 1.1rem;
  }
}
.header {
  padding-block-start: 5rem;
  margin-block-end: 2rem;
  background-color: var(--v-primary-base);
  &__secondary {
    margin-top: -9.5rem;
    background-size: cover;
    background-position: center;
    background-image: url("../../../assets/images/landing/pink-gradient.jpg");
    @media (max-width: 1200px) {
      margin-top: 0rem;
    }
  }
}
.ws-odd-row {
  > div:first-child {
    order: 13 !important;
    @media (max-width: 767px) {
      order: -1 !important;
    }
  }
  .title-glow {
    left: 2%;
    right: unset;
  }
}
.section-lg {
  font-size: 1.5em;
  padding-block: 3rem;
  @media (max-width: 767px) {
    font-size: 1.2em;
  }
}

.v-application .body-1,
.v-application .caption {
  font-family: "Lato-Regular" !important;
}
</style>
